module.exports = __webpack_public_path__ + "img/jacobins.b651d0b3.jpg";